import { Modal } from 'antd';

const ConnectionErrorModal = (
  okFunction,
  okFunctionParameter,
  okText,
  errorMessage
) => {
  Modal.warning({
    title: 'Connection not available',
    content: errorMessage,
    closable: true,
    okText,
    onOk: () => {
      okFunction(okFunctionParameter);
    },
  });
};

export default ConnectionErrorModal;
